module.exports = __webpack_public_path__ + "static/media/10660287_708424022584953_5134500964517843633_n.ba640c00.jpg";